import { render, staticRenderFns } from "./prove.vue?vue&type=template&id=0709b4d4&scoped=true"
import script from "./prove.vue?vue&type=script&lang=js"
export * from "./prove.vue?vue&type=script&lang=js"
import style0 from "./prove.vue?vue&type=style&index=0&id=0709b4d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709b4d4",
  null
  
)

export default component.exports